module.exports = __webpack_public_path__ + "5b22cc6ce417ddbbef468c42c971fb9e.jpg";